import React from 'react';
import { Button } from 'antd';
import { FaEdit } from 'react-icons/fa';
import { buildEditorUrl } from '../../../../config/environment';

function OpenInEditor({ document, style = {} }) {
  const openInEditor = () => {
    // Documento gerado pelo sistema interno - abrir no editor com type=document
    if (document.id) {
      const editorUrl = `${buildEditorUrl(document.id)}?type=document`;
      window.open(editorUrl, '_blank');
    } else if (document.webViewLink && document.mimeType === 'application/vnd.google-apps.document') {
      // Documento do Google Drive - abrir no editor externo primeiro, depois interno
      const editUrl = document.webViewLink.replace('/view?', '/edit?');
      window.open(editUrl, '_blank');
    } else if (document.webViewLink) {
      // Para outros tipos de documento do Google Drive
      window.open(document.webViewLink, '_blank');
    } else {
      console.warn('Documento não editável ou sem conteúdo:', document);
    }
  };


  const isEditable = document.content || 
                     document.mimeType === 'application/vnd.google-apps.document' || 
                     document.name?.toLowerCase().includes('.doc') ||
                     document.name?.toLowerCase().includes('.odt');

  if (!isEditable) {
    return null; 
  }

  return (
    <Button
      type="text"
      size="small"
      icon={<FaEdit />}
      onClick={openInEditor}
      title="Abrir no Editor"
      style={{ 
        color: '#722ed1',
        ...style
      }}
    />
  );
}

export default OpenInEditor;
